import React, {useContext, useState} from 'react';
import times from 'lodash/times';
import './Rate.less';
import {RateItem} from "elements/rate-item/RateItem";
import {RateTitle} from "elements/rate-title/RateTitle";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const Rate = ({currentValue, maxValue, onChange}) => {
	const [plannedValue, setPlannedValue] = useState(null);

	const translations = useContext(TranslationsContext);

	return <div className="rate">
		<div className="rate__title">
			<RateTitle text={getSafeTranslation('Rate.title', translations)}/>
		</div>
		<ul className="rate__controls">
			{
				times(maxValue, index =>
					<li className="rate__control" key={index}>
						<RateItem
							onMouseLeave={() => setPlannedValue(null)}
							onMouseEnter={() => setPlannedValue(index + 1)}
							isPlanned={plannedValue && index < plannedValue}
							isActive={!plannedValue && index < currentValue}
							onClick={() => onChange(index + 1)}

						/>
					</li>
				)
			}
		</ul>
	</div>
}
